import { useEffect, useState } from "react";
import { API_BASE } from "../api";
import { usePlayer } from "../contexts/PlayerContext";
import type { CanonicalWork, TranscriptSegment } from "../generated/contracts";
export function Transcript({ work }: { work: CanonicalWork }) {
  const [segments, setSegments] = useState<TranscriptSegment[]>([]),
    [query, setQuery] = useState("");
  const player = usePlayer();
  useEffect(() => {
    let live = true;
    fetch(
      `${API_BASE}/api/v2/archive/works/${encodeURIComponent(work.slug)}/transcript`,
    )
      .then(async (r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (live) setSegments(d?.segments || []);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [work.slug]);
  if (!segments.length) return null;
  return (
    <section className="public-transcript">
      <header>
        <h2>Follow along.</h2>
        <label>
          Find in transcript
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search the words…"
          />
        </label>
      </header>
      <p>
        Reviewed transcript · Select a timestamp to listen from that moment.
      </p>
      {segments
        .filter(
          (s) => !query || s.text.toLowerCase().includes(query.toLowerCase()),
        )
        .map((s) => (
          <div
            className={
              player.current?.id === work.id &&
              player.currentTime >= s.startSeconds &&
              player.currentTime < s.endSeconds
                ? "transcript-line active"
                : "transcript-line"
            }
            key={s.id}
            id={`t-${Math.floor(s.startSeconds)}`}
          >
            <button
              aria-label={`Listen from ${Math.floor(s.startSeconds / 60)} minutes ${Math.floor(s.startSeconds % 60)} seconds`}
              onClick={() => player.load(work, undefined, s.startSeconds)}
            >
              {Math.floor(s.startSeconds / 60)}:
              {String(Math.floor(s.startSeconds % 60)).padStart(2, "0")}
            </button>
            <p>
              {s.text}
              <a
                href={`?t=${Math.floor(s.startSeconds)}#t-${Math.floor(s.startSeconds)}`}
              >
                Link to this moment
              </a>
            </p>
          </div>
        ))}
    </section>
  );
}
